import { BaSeButton, BaSeParagraph, BaSeTheme } from '@base/react';
import * as React from 'react';

export const GetPortfolioModal = ({ onConfirm, onCancel, onClose }) => {
  const { cinzaSebrae45, azulSebrae36 } = BaSeTheme.colors.institucionais;

  const handleConfirm = () => {
    onConfirm();
    if (onClose?.closeModal) {
      onClose.closeModal();
    }
  };

  const handleCancel = () => {
    if (onClose?.closeModal) {
      onClose.closeModal();
    }
  };

  return (
    <>
      <div>
        <BaSeParagraph color={cinzaSebrae45}>
          Já existem dados preenchidos. Ao buscar, todos os dados serão
          substituídos pelo resultado da busca.
        </BaSeParagraph>
        <BaSeParagraph color={cinzaSebrae45}>Deseja prosseguir?</BaSeParagraph>
      </div>
      <div style={{ marginTop: 35, display: 'flex', gap: 10 }}>
        <BaSeButton
          isLoading={false}
          isDisabled={false}
          color={azulSebrae36}
          value="Sim, buscar"
          onClick={handleConfirm}
        />
        <BaSeButton
          type="secondary"
          color={azulSebrae36}
          value="Não, desistir da busca"
          onClick={handleCancel}
        />
      </div>
    </>
  );
};

export const getPortfolioModalConfig = (onConfirm, onCancel) => ({
  title: 'Atenção!',
  content: (onClose) => (
    <GetPortfolioModal
      onConfirm={onConfirm}
      onCancel={onCancel}
      onClose={onClose}
    />
  ),
  actions: [],
  size: 'medium',
});
